type TickerDetails = {
  t: string;
  n: string;
  s: string;
  i: string;
};

const MAX_TICKERS = 20;

export const searchTickerFilter = (
  query: string = '',
  data: TickerDetails[] = [],
): TickerDetails[] => {
  const searchTerm = query.trim().toLowerCase();

  if (!searchTerm) {
    return [];
  }

  const addedTickers = new Set<string>();
  const filteredTickers: TickerDetails[] = [];

  // Add exact match for ticker symbol
  const exactMatchTicker = data.find((ticker) => ticker.t.toLowerCase() === searchTerm);
  if (exactMatchTicker) {
    filteredTickers.push(exactMatchTicker);
    addedTickers.add(exactMatchTicker.t);
  }

  // Helper function to add tickers if they aren't already added
  const tryAddTicker = (ticker: TickerDetails) => {
    if (!addedTickers.has(ticker.t) && filteredTickers.length < MAX_TICKERS) {
      filteredTickers.push(ticker);
      addedTickers.add(ticker.t);
    }
  };

  // Add tickers that match symbol and then name
  data.forEach((ticker) => {
    if (ticker.t.toLowerCase().includes(searchTerm)) {
      tryAddTicker(ticker);
    } else if (ticker?.n?.toLowerCase().includes(searchTerm)) {
      tryAddTicker(ticker);
    }
  });

  return filteredTickers;
};
